export default __webpack_public_path__ + "static/media/unhrc agenda.5b2d0a08.png";